import React from "react";
import PropTypes from "prop-types";
import getFilesUrl from "../../../helpers/getFilesUrl";
import Translations from "./translations";
import languages from "../../../data/languages";
import { addPhoto } from "./requests/addPhoto";
import { addNews } from "./requests/addNews";

const languageTemplate = {
  title: "",
  content: "",
  language: "",
  image: {
    id: "",
    node: ""
  },
};

class EditModal extends React.Component {
  constructor(props) {
    super(props);

    const { data } = this.props;

    const translations = data && data.translations ? data.translations : Object.keys(languages)
      .map(langKey => ({
        ...languageTemplate,
        language: langKey,
      }));

    this.state = {
      id: data ? data.id : false,
      active: data ? Boolean(data.active) : false,
      url: data ? data.url : "",
      translations,
      previewImages: Object.keys(languages)
        .reduce((result, langKey) => {
          const item = translations && translations.find(item => item.language === langKey);
          result[langKey] = {
            file: false,
            preview: item && item.image ? getFilesUrl(item.image) : "",
          };
          return result;
        }, {})
    };
  }


  handleChangeImage = (lang, ev) => {
    const file = ev.target.files[0];
    this.setState({
      previewImages: {
        ...this.state.previewImages,
        [lang]: {
          file,
          preview: URL.createObjectURL(file),
        },
      }
    });
  };

  handleChangeLanguage = (lang, name, value) => {
    const translations = [...this.state.translations];

    const languageItemIndex = translations.findIndex(i => i.language === lang);
    const languageItem = (languageItemIndex === -1) ? { ...languageTemplate } : { ...translations[languageItemIndex] };

    languageItem.language = lang;
    languageItem[name] = value;

    this.setState({
      translations: [
        ...this.state.translations.filter(i => i.language !== lang),
        languageItem
      ]
    });
  };

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value
    });
  };

  handleSubmit = async () => {
    const data = Object.assign({}, this.state);

    const mainNews = {
      id: data.id,
      url: data.url,
      active: data.active,
      translations: data.translations,
    };
    if (!mainNews.id) {
      delete mainNews.id;
    }

    const result = await addNews(mainNews);
    const newsId = result && result.data ? result.data.content.id : data.id;

    const { previewImages } = this.state;
    for (const langKey in previewImages) {
      if (previewImages[langKey].file) {
        await addPhoto(newsId, langKey, previewImages[langKey].file);
      }
    }

    this.props.onSuccess();
  };

  render() {
    const {
      url,
      active,
      translations,
      previewImages,
    } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-3">
            <div className="form-group">
              <label>Active</label>
              <select
                className="form-control form-control-sm"
                onChange={ev => this.setState({
                  active: Boolean(+ev.target.value)
                })}
                value={active ? "1" : "0"}
              >
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
          <div className="col-9">
            <div className="form-group">
              <label>URL</label>
              <input
                className="form-control form-control-sm"
                type="text"
                value={url || ""}
                name="url"
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="col-12">
            <Translations
              onChange={this.handleChangeLanguage}
              onChangeImage={this.handleChangeImage}
              previewImages={previewImages}
              translations={translations}
            />
          </div>
        </div>
        <div className="text-right mt-2">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

EditModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default EditModal;



// WEBPACK FOOTER //
// ./src/views/pages/news/edit-modal.js